import { Stack } from '@mui/material';
import { PerformersLabel } from './PerformersLabel';
import { apiSlugToDimensionName } from '@components/Dashboard/dashboardSlice/responseMappers/dimensionStats';
import {
  PerformersCheckbox,
  PerformersCheckboxProps,
} from './PerformersCheckbox';

export type PerformersGroupProps = {
  type: 'top' | 'bottom';
  options: (PerformersCheckboxProps['option'] & { name: string })[];
  onChange: (name: string, value: string, checked: boolean) => void;
};

export const PerformersGroup = (props: PerformersGroupProps) => {
  return (
    <Stack direction="column" spacing="0.25rem">
      <PerformersLabel type={props.type} />
      <Stack
        direction="column"
        spacing="0.5rem"
        data-testid={`${props.type}-performers`}
      >
        {props.options.map(option => {
          const label = [
            apiSlugToDimensionName[
              option.name as keyof typeof apiSlugToDimensionName
            ],
            option.value,
          ].join(' | ');

          return (
            <PerformersCheckbox
              onChange={(_e, checked) =>
                props.onChange(option.name, option.value, checked)
              }
              option={option}
              key={label}
              label={label}
            />
          );
        })}
      </Stack>
    </Stack>
  );
};
